import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { EmployeesTab } from "./admin/EmployeesTab";
import { AccessTab } from "./admin/AccessTab";
import { LoadsTab } from "./admin/LoadsTab";
import { SettingsTab } from "./admin/SettingsTab";
import { LogsTab } from "./admin/LogsTab";

type AdminTab = "employees" | "access" | "loads" | "settings" | "logs";
const TABS: Array<{ id: AdminTab; key: string }> = [
  { id: "employees", key: "admin_tab_employees" },
  { id: "access", key: "admin_tab_access" },
  { id: "loads", key: "admin_tab_loads" },
  { id: "settings", key: "admin_tab_settings" },
  { id: "logs", key: "admin_tab_logs" },
];

export function AdminScreen() {
  const { setShowAdmin, t, adminInitialTab, setAdminInitialTab } = useAuth();
  const [tab, setTab] = useState<AdminTab>((adminInitialTab as AdminTab | null) ?? "employees");

  function close() {
    setAdminInitialTab(null);
    setShowAdmin(false);
  }

  return (
    <div className="fixed inset-0 z-50 bg-slate-100 flex flex-col">
      <header className="bg-gradient-to-br from-teal-600 to-emerald-600 text-white px-5 pt-12 pb-3 flex items-center justify-between flex-shrink-0">
        <div className="text-base font-semibold">{t("admin_title")}</div>
        <button
          onClick={close}
          className="bg-white/15 hover:bg-white/25 text-white text-xs font-semibold rounded-full px-3 py-1.5 transition"
        >{t("admin_close")}</button>
      </header>

      <div className="flex bg-white border-b border-slate-200 flex-shrink-0 overflow-x-auto">
        {TABS.map(x => (
          <button
            key={x.id}
            onClick={() => setTab(x.id)}
            className={`flex-1 whitespace-nowrap px-2 py-3 text-xs font-medium ${tab === x.id ? "text-teal-700 border-b-2 border-teal-600" : "text-slate-500"}`}
          >{t(x.key)}</button>
        ))}
      </div>

      <main className="flex-1 overflow-y-auto">
        {tab === "employees" && <EmployeesTab />}
        {tab === "access" && <AccessTab />}
        {tab === "loads" && <LoadsTab />}
        {tab === "settings" && <SettingsTab />}
        {tab === "logs" && <LogsTab />}
      </main>
    </div>
  );
}
